import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * A custom element that displays product materials metafield.
 * Updates automatically when variants change, with fallback to product-level metafields.
 */
class ProductMaterials extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateMaterials);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateMaterials);
  }

  /**
   * Updates the materials display when variant changes.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateMaterials = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newMaterials = event.detail.data.html.querySelector('product-materials');

    if (!newMaterials) {
      // No materials for this variant - hide the current block
      this.style.display = 'none';
      return;
    }

    // Show the block if it was hidden
    this.style.display = 'block';

    // Update the content
    morph(this, newMaterials, { childrenOnly: true });
  };
}

if (!customElements.get('product-materials')) {
  customElements.define('product-materials', ProductMaterials);
}
